/* Agatha redesign: shared runtime, window.Agatha (test theme). Owned by the foundation builder.
   Loaded deferred, before the other agatha-*.js files, so they can use window.Agatha directly.

   Agatha.locale            'fr' or 'en'
   Agatha.root              Shopify.routes.root ('/' or '/fr/')
   Agatha.AGES              [{id, fr, en, cm, lo, hi}] (the prototype's nine ages; lo/hi in months)
   Agatha.ageName(id)       label of an age in the current locale
   Agatha.getAge()          remembered age id or null (localStorage 'agatha-age')
   Agatha.setAge(id|null)   remember / forget; fires 'agatha:age' on document ({detail: {age}})
   Agatha.parseAge(label)   size label -> [ageIds] (port of tools/build_data.py parse_age + buckets_for)
   Agatha.parseAgeRange(l)  size label -> [loMonth, hiMonth] or null (parse_age itself)
   Agatha.ageMap()          Promise of assets/agatha-age-map.json
   Agatha.ageQuery(ageId)   Promise of {size, taille, sizeLabels, tailleLabels, sizeCount, tailleCount}
                            size/taille are query strings ('filter.v.option.size=...&...'), OR of every
                            label of that age in the current locale (the age map, plus any label the
                            page's filters list that the map lacks and parseAge places in that age);
                            *Count = number of labels.
   Agatha.count(url)        Promise of the product count of a collection URL (filters kept), through
                            the Section Rendering API and sections/agatha-count.liquid.
*/
(function () {
  'use strict';

  var cfg = window.AgathaConfig || {};
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || cfg.root || '/';
  var locale = String(cfg.locale || document.documentElement.lang || 'en').slice(0, 2).toLowerCase() === 'fr' ? 'fr' : 'en';

  // Heights are rounded WHO/CDC median statures (tools/build_data.py AGES), shown as "environ".
  var AGES = [
    { id: 'naissance', fr: 'Naissance', en: 'Newborn', cm: 50, lo: 0, hi: 3 },
    { id: '6-mois', fr: '6 mois', en: '6 months', cm: 67, lo: 3, hi: 9 },
    { id: '1-an', fr: '1 an', en: '1 year', cm: 75, lo: 9, hi: 18 },
    { id: '2-ans', fr: '2 ans', en: '2 years', cm: 87, lo: 18, hi: 36 },
    { id: '4-ans', fr: '4 ans', en: '4 years', cm: 103, lo: 36, hi: 60 },
    { id: '6-ans', fr: '6 ans', en: '6 years', cm: 116, lo: 60, hi: 84 },
    { id: '8-ans', fr: '8 ans', en: '8 years', cm: 128, lo: 84, hi: 108 },
    { id: '10-ans', fr: '10 ans', en: '10 years', cm: 138, lo: 108, hi: 132 },
    { id: '12-ans', fr: '12 ans et +', en: '12 years +', cm: 149, lo: 132, hi: 192 }
  ];
  var AGE_IDS = AGES.map(function (a) { return a.id; });
  var AGE_KEY = 'agatha-age';

  function ageName(id) {
    for (var i = 0; i < AGES.length; i++) if (AGES[i].id === id) return AGES[i][locale];
    return '';
  }

  function getAge() {
    var v = null;
    try { v = window.localStorage.getItem(AGE_KEY); } catch (e) { return null; }
    if (v && v.charAt(0) === '"') {
      try { v = JSON.parse(v); } catch (e) { v = null; }
    }
    return AGE_IDS.indexOf(v) === -1 ? null : v;
  }

  function setAge(id) {
    var age = AGE_IDS.indexOf(id) === -1 ? null : id;
    try {
      if (age) window.localStorage.setItem(AGE_KEY, age);
      else window.localStorage.removeItem(AGE_KEY);
    } catch (e) { /* private mode or blocked storage: keep going */ }
    try { document.dispatchEvent(new CustomEvent('agatha:age', { detail: { age: age } })); } catch (e) { /* old browser */ }
    return age;
  }

  // ---------- parse_age: faithful port of tools/build_data.py ----------
  // Python's \s, str.strip() and \b (Unicode word chars) are reproduced exactly; Python's round()
  // is round-half-to-even. Only non-ASCII decimal digits (never seen in the catalogue) differ.
  var WS = '[\\t\\n\\x0b\\x0c\\r\\x1c-\\x1f \\x85\\xa0\\u1680\\u2000-\\u200a\\u2028\\u2029\\u202f\\u205f\\u3000]';
  var S = WS + '*';
  var B = '(?![\\p{L}\\p{N}_])';
  var MONTH = '(?:m|mois|months?|mo)' + B;
  var YEAR = '(?:ans?|y|years?|a)' + B;
  var TODDLER = '(?:t|tonnes?)' + B;
  var STRIP = new RegExp('^' + WS + '+|' + WS + '+$', 'gu');

  function full(src) { return new RegExp('^(?:' + src + ')$', 'u'); }
  function start(src) { return new RegExp('^(?:' + src + ')', 'u'); }
  function pyStrip(s) { return s.replace(STRIP, ''); }
  function pyInt(s) { return parseInt(pyStrip(s), 10); }
  function pyRound(x) {
    var f = Math.floor(x);
    var d = x - f;
    if (d > 0.5) return f + 1;
    if (d < 0.5) return f;
    return f % 2 === 0 ? f : f + 1;
  }

  var RE = {
    skip: /pièce|pieces|boîte|kg|pointure|x-|\*|juillet/u,
    fois: full('(\\d+)' + S + '(?:à|-)' + S + '(\\d+)' + S + 'fois'),
    millions: full('(\\d+)' + S + 'millions?'),
    around: new RegExp('\\((?:autour de )?(\\d+)' + S + 'an', 'u'),
    paren: /\(([^)]*)\)/u,
    digit: /\d/u,
    slashPair: full('\\d+/\\d+'),
    slashPairCap: full('(\\d+)/(\\d+)'),
    parens: /\([^\n]*?\)/gu,
    monthToYear: full('(\\d+)' + S + MONTH + S + '(?:à|-|to)' + S + '(\\d+)' + S + YEAR),
    monthRange: start('(\\d+)' + S + 'm?' + S + '(?:-|à|–|/)' + S + '(\\d+)' + S + MONTH),
    month: full('(\\d+)' + S + MONTH),
    toddlerRange: full('(\\d+)' + S + '(?:-|/|à)' + S + '(\\d+)' + S + TODDLER),
    toddler: full('(\\d+)' + S + TODDLER),
    yearRange: full('(\\d+)' + S + '(?:' + YEAR + ')?' + S + '(?:-|/|à|to)' + S + '(\\d+)' + S + YEAR),
    year: full('(\\d+)' + S + YEAR),
    cm: full('(\\d{3})'),
    bare: full('(\\d+)x?'),
    bareRange: full('(\\d+)' + S + '(?:-|à)' + S + '(\\d+)')
  };

  var HEIGHT_TO_MONTHS = [
    [50, 0], [61, 3], [67, 6], [75, 12], [82, 18], [87, 24], [96, 36], [103, 48], [110, 60], [116, 72],
    [122, 84], [128, 96], [133, 108], [138, 120], [144, 132], [149, 144], [156, 156], [163, 168], [170, 192]
  ];

  function heightMonths(cm) {
    var pts = HEIGHT_TO_MONTHS;
    if (cm <= pts[0][0]) return 0;
    for (var i = 0; i < pts.length - 1; i++) {
      var h0 = pts[i][0], m0 = pts[i][1], h1 = pts[i + 1][0], m1 = pts[i + 1][1];
      if (cm <= h1) return m0 + ((m1 - m0) * (cm - h0)) / (h1 - h0);
    }
    return 192;
  }

  function monthsOf(v) { return v <= 12 ? [Math.max(0, v - 3), v] : [v - 6, v]; }

  function parseAgeRange(label) {
    if (label === null || label === undefined) return null;
    var s = pyStrip(String(label).toLowerCase().split(' ').join(' ').split(' old').join(''));
    var m;
    if (RE.skip.test(s)) return null;
    // "4 à 6 fois" / "2-3 tonnes" are live mistranslations of "4-6X" / "2-3T"
    if ((m = s.match(RE.fois))) return [12 * pyInt(m[1]), 12 * pyInt(m[2]) + 12];
    if (s.indexOf('fois') !== -1) return null;
    // "12 millions" is a live mistranslation of "12M" (12 months)
    if ((m = s.match(RE.millions))) return monthsOf(pyInt(m[1]));
    if (s === 'nb' || s === 'nouveau-né' || s === 'newborn' || s === 'prématuré') return [0, 3];
    // explicit hints win: "5 (autour de 1 an)", "Small (6-12mois)", "Child (2-6 years old)"
    if ((m = s.match(RE.around))) {
      var y = pyInt(m[1]);
      return [12 * y, 12 * y + 12];
    }
    m = s.match(RE.paren);
    if (m && RE.digit.test(m[1]) && !RE.slashPair.test(pyStrip(m[1]))) {
      var inner = parseAgeRange(m[1]);
      if (inner) return inner;
    }
    if (m && RE.slashPairCap.test(pyStrip(m[1]))) { // "6 (6/7)", "6X (7/8)"
      var ab = m[1].split('/');
      return [12 * pyInt(ab[0]), 12 * pyInt(ab[1]) + 12];
    }
    s = pyStrip(s.replace(RE.parens, ''));
    if (s.indexOf('nb') === 0) s = s.split('nb').join('0m');
    // "6 mois à 2 ans", "18 months-4 years"
    if ((m = s.match(RE.monthToYear))) return [pyInt(m[1]), 12 * pyInt(m[2]) + 12];
    // month ranges "3-6 mois", "6-12M", "18M-24M", "0-12 mois pantalon mini"
    if ((m = s.match(RE.monthRange))) return [pyInt(m[1]), pyInt(m[2])];
    if ((m = s.match(RE.month))) return monthsOf(pyInt(m[1]));
    // toddler sizes "2T", "1/2T", "1-3 T", "2-3 tonnes", "5-6T"
    if ((m = s.match(RE.toddlerRange))) return [12 * pyInt(m[1]), 12 * pyInt(m[2]) + 12];
    if ((m = s.match(RE.toddler))) {
      var t = pyInt(m[1]);
      return [12 * t, 12 * t + 12];
    }
    // year ranges "7/8 ans", "9/10Y", "2 ans à 4 ans", "4-6 years", "3 à 5 ans"
    if ((m = s.match(RE.yearRange))) return [12 * pyInt(m[1]), 12 * pyInt(m[2]) + 12];
    if ((m = s.match(RE.year))) {
      var v = pyInt(m[1]);
      return [12 * v, 12 * v + 12];
    }
    // stature in cm "130"
    m = s.match(RE.cm);
    if (m && pyInt(m[1]) >= 50 && pyInt(m[1]) <= 176) {
      var c = pyInt(m[1]);
      return [pyRound(heightMonths(c - 5)), pyRound(heightMonths(c + 5))];
    }
    // bare kids' sizes "2", "10", "6X", "9-10", "7-16", "12-16"
    m = s.match(RE.bare);
    if (m && pyInt(m[1]) >= 1 && pyInt(m[1]) <= 16) {
      var b = pyInt(m[1]);
      return [12 * b, 12 * b + 12];
    }
    m = s.match(RE.bareRange);
    if (m && pyInt(m[1]) >= 1 && pyInt(m[1]) < pyInt(m[2]) && pyInt(m[2]) <= 16) {
      return [12 * pyInt(m[1]), 12 * pyInt(m[2]) + 12];
    }
    return null;
  }

  function bucketsFor(ranges) {
    return AGES.filter(function (a) {
      return ranges.some(function (r) { return r[0] < a.hi && r[1] > a.lo; });
    }).map(function (a) { return a.id; });
  }

  function parseAge(label) {
    var r = parseAgeRange(label);
    return r ? bucketsFor([r]) : [];
  }

  // ---------- age map (static asset generated by tools/build_age_map.py) ----------
  var mapPromise = null;
  var EMPTY_MAP = { generated: null, ages: AGE_IDS, en: {}, fr: {} };

  function ageMap() {
    if (!mapPromise) {
      mapPromise = cfg.ageMapUrl
        ? fetch(cfg.ageMapUrl, { credentials: 'same-origin' })
            .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
            .catch(function (e) {
              if (window.console) console.warn('Agatha: age map unavailable', e);
              return EMPTY_MAP;
            })
        : Promise.resolve(EMPTY_MAP);
    }
    return mapPromise;
  }

  var FILTERS = ['size', 'taille'];

  // Size labels this page lists: Dawn's filter inputs, or the collection section's
  // [data-ag-age-values] JSON when filtering is off. A label added to the catalogue (or translated)
  // after the age map was generated is found here and classified with parseAge, the parser the map
  // itself was built with.
  function pageLabels(key) {
    var out = [];
    try {
      var inputs = document.querySelectorAll('input[name="filter.v.option.' + key + '"]');
      for (var i = 0; i < inputs.length; i++) out.push(inputs[i].value);
      var el = document.querySelector('[data-ag-age-values]');
      if (el) {
        var j = JSON.parse(el.textContent || '{}');
        (j[key] || []).forEach(function (v) { if (v) out.push(String(v)); });
      }
    } catch (e) { /* no DOM or bad JSON: map labels only */ }
    return out;
  }

  function ageQuery(ageId) {
    return ageMap().then(function (map) {
      var loc = map[locale] || {};
      var out = {};
      FILTERS.forEach(function (key) {
        var values = loc[key] || {};
        var labels = Object.keys(values).filter(function (l) {
          return values[l] && values[l].indexOf(ageId) !== -1;
        });
        // The map stays the main source (it covers labels beyond the 100 a filter lists); the page
        // adds only labels the map does not know.
        pageLabels(key).forEach(function (l) {
          if (Object.prototype.hasOwnProperty.call(values, l) || labels.indexOf(l) !== -1) return;
          if (parseAge(l).indexOf(ageId) !== -1) labels.push(l);
        });
        labels.sort();
        out[key] = labels.map(function (l) {
          return 'filter.v.option.' + key + '=' + encodeURIComponent(l);
        }).join('&');
        out[key + 'Labels'] = labels;
        out[key + 'Count'] = labels.length;
      });
      return out;
    });
  }

  // ---------- counts through the Section Rendering API ----------
  var countCache = new Map();
  var queue = [];
  var running = 0;
  var MAX_PARALLEL = 4;

  function pump() {
    while (running < MAX_PARALLEL && queue.length) {
      var job = queue.shift();
      running++;
      job().then(done, done);
    }
    function done() { running--; pump(); }
  }

  function readCount(html) {
    var doc = new DOMParser().parseFromString(String(html || ''), 'text/html');
    var el = doc.querySelector('[data-ag-count]');
    if (!el) throw new Error('agatha-count: no [data-ag-count]');
    var raw = el.getAttribute('data-ag-count');
    if (!/^\d+$/.test(raw || '')) raw = (el.textContent || '').replace(/[^\d]/g, '');
    if (!raw) throw new Error('agatha-count: empty count');
    return parseInt(raw, 10);
  }

  function count(url) {
    var u = new URL(url, window.location.origin);
    u.searchParams.delete('page');
    u.searchParams.delete('section_id');
    u.searchParams.set('sections', 'agatha-count');
    u.search = window.AgathaAvailability.params(u.searchParams, u.pathname).toString();
    var key = u.pathname + u.search;
    if (countCache.has(key)) return countCache.get(key);
    var p = new Promise(function (resolve, reject) {
      queue.push(function () {
        // No Accept: application/json header: with it Shopify answers ?sections= with the collection
        // JSON (like /collections/x.json) instead of the {"agatha-count": "<html>"} sections payload.
        return fetch(key, { credentials: 'same-origin' })
          .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
          .then(function (json) { return readCount(json && json['agatha-count']); })
          .then(resolve, reject);
      });
      pump();
    });
    p.catch(function () { countCache.delete(key); });
    countCache.set(key, p);
    return p;
  }

  window.Agatha = Object.assign(window.Agatha || {}, {
    locale: locale,
    root: root,
    AGES: AGES,
    ageName: ageName,
    getAge: getAge,
    setAge: setAge,
    parseAge: parseAge,
    parseAgeRange: parseAgeRange,
    ageMap: ageMap,
    ageQuery: ageQuery,
    count: count
  });
})();
